import axios from 'axios';
import * as types from './types';

function generateQueriesFromFilter(state) {
  const formfactor = state.filters.formfactor ? `formfactor=${state.filters.formfactor}` : '';
  const age = state.filters.age ? `age=${state.filters.age}` : '';
  const utilisation = state.filters.utilisation ? `utilisation=${state.filters.utilisation}` : '';
  const warranty = state.filters.warranty ? `warranty=${state.filters.warranty}` : '';
  const buildNumber = state.filters.buildNumber ? `buildNumber=${state.filters.buildNumber}` : '';
  const operatingSystem = state.filters.operatingSystem ? `operatingSystem=${state.filters.operatingSystem}` : '';
  const model = state.filters.model ? `model=${state.filters.model}` : '';

  let queries = [];
  if (formfactor) {
    queries.push(formfactor);
  }
  if (age) {
    queries.push(age);
  }
  if (utilisation) {
    queries.push(utilisation);
  }
  if (warranty) {
    queries.push(warranty);
  }
  if (buildNumber) {
    queries.push(buildNumber);
  }
  if (operatingSystem) {
    queries.push(operatingSystem);
  }
  if (model) {
    queries.push(model);
  }

  if (queries.length > 0) {
    return queries.join('&');
  } else {
    return '';
  }
}

export default {
  /// form-factor
  async fetchFormFactorForChart({dispatch, state}, {sitecode}) {
    const url = `/charts/devices/form-factor/${sitecode}?`;
    const queries = generateQueriesFromFilter(state);

    const response = await dispatch('api', {
      method: 'GET',
      url: `${url}${queries}`,
      types: [
        types.FORM_FACTOR_REQUEST,
        types.FORM_FACTOR_SUCCESS,
        types.FORM_FACTOR_FAILURE,
      ]
    });

    return response;
  },

  /// model-count
  async fetchModelCountForChart({dispatch, state}, {sitecode}) {
    const url = `/charts/devices/model-count/${sitecode}?`;
    const queries = generateQueriesFromFilter(state);

    const response = await dispatch('api', {
      method: 'GET',
      url: `${url}${queries}`,
      types: [
        types.MODEL_COUNT_REQUEST,
        types.MODEL_COUNT_SUCCESS,
        types.MODEL_COUNT_FAILURE,
      ]
    });

    return response;
  },

  /// warranty
  async fetchWarrantyForChart({dispatch, state}, {sitecode}) {
    const url = `/charts/devices/warranty/${sitecode}?`;
    const queries = generateQueriesFromFilter(state);

    const response = await dispatch('api', {
      method: 'GET',
      url: `${url}${queries}`,
      types: [
        types.WARRANTY_REQUEST,
        types.WARRANTY_SUCCESS,
        types.WARRANTY_FAILURE,
      ]
    });

    return response;
  },

  /// age
  async fetchDeviceAgesForChart({dispatch, state}, {sitecode}) {
    const url = `/charts/devices/age/${sitecode}?`;
    const queries = generateQueriesFromFilter(state);

    const response = await dispatch('api', {
      method: 'GET',
      url: `${url}${queries}`,
      types: [
        types.AGE_REQUEST,
        types.AGE_SUCCESS,
        types.AGE_FAILURE,
      ]
    });

    return response;
  },

  /// utilisation
  async fetchDeviceUtilisationChart({dispatch, state}, {sitecode}) {
    const url = `/charts/devices/utilisation/${sitecode}?`;
    const queries = generateQueriesFromFilter(state);

    const response = await dispatch('api', {
      method: 'GET',
      url: `${url}${queries}`,
      types: [
        types.UTILISATION_REQUEST,
        types.UTILISATION_SUCCESS,
        types.UTILISATION_FAILURE,
      ]
    });

    return response;
  },

  /// devices
  async fetchDevices({dispatch, state}, {sitecode, descending, sortBy, page, rowsPerPage}) {
    let url = `/devices/${sitecode}?`;
    let queries = generateQueriesFromFilter(state);

    if (queries) {
      if (sortBy) {
        if (descending) {
          queries = `${queries}&sort=[{"${sortBy}": "desc"}]`;
        } else {
          queries = `${queries}&sort=[{"${sortBy}": "asc"}]`;
        }
      }
    }

    if (sitecode) {
      return await dispatch('api', {
        method: 'GET',
        url: `${url}${queries}`,
        types: [
          types.DEVICES_REQUEST,
          types.DEVICES_SUCCESS,
          types.DEVICES_FAILURE,
        ]
      });
    }
  },

  /// Top 10 build number
  async fetchTop10BuildNumberForChart({dispatch, state}, {sitecode}) {
    const url = `/charts/devices/build-number/${sitecode}?`;
    const queries = generateQueriesFromFilter(state);

    const response = await dispatch('api', {
      method: 'GET',
      url: `${url}${queries}`,
      types: [
        types.BUILD_NUMBER_COUNT_REQUEST,
        types.BUILD_NUMBER_COUNT_SUCCESS,
        types.BUILD_NUMBER_COUNT_FAILURE,
      ]
    });
    return response;
  },

  /// Top 10 build number
  async fetchTop10OperatingSystemForChart({dispatch, state}, {sitecode}) {
    const url = `/charts/devices/operating-system/${sitecode}?`;
    const queries = generateQueriesFromFilter(state);

    const response = await dispatch('api', {
      method: 'GET',
      url: `${url}${queries}`,
      types: [
        types.OPERATING_SYSTEM_COUNT_REQUEST,
        types.OPERATING_SYSTEM_COUNT_SUCCESS,
        types.OPERATING_SYSTEM_COUNT_FAILURE,
      ]
    });
    return response;
  },

  setDevicePagination({commit}, pagination) {
    commit('setPagination', pagination);
  },

  async fetchDeviceCount({dispatch}, sitecode) {
    const response = await dispatch('api', {
      method: 'GET',
      url: `/devices/${sitecode}/count`,
      types: [
        types.DEVICE_COUNT_REQUEST,
        types.DEVICE_COUNT_SUCCESS,
        types.DEVICE_COUNT_FAILURE,
      ]
    });
    return response;
  },


  /// device data drill down
  setFilter({commit}, {field, value}) {
    commit('setFilter', {field: field, value: value})
  },

  clearFilter({commit}, field) {
    commit('clearFilter', field);
  },

  clearAllFilters({commit}) {
    commit('clearAllFilters');
  },

  /// hourly-bandwidth-usage
  async fetchHourlyBandwidthUsage({dispatch, commit}, {sitecode, dateRange, searchInput}) {
    commit(types.HOURLY_BANDWIDTH_USAGE_FETCH_REQUEST);
    let queries = [];

    if (dateRange) {
      if (dateRange.startDate) {
        queries.push(`startDate=${dateRange.startDate}`);
      }
      if (dateRange.endDate) {
        queries.push(`endDate=${dateRange.endDate}`);
      }
    }

    if (searchInput) {
      queries.push(`search=${searchInput}`);
    }

    const departmentPromise = dispatch('api', {
      method: 'GET',
      url: `/charts/fib/hourly/${sitecode}?isdepartment=true&${queries.join('&')}`,
      types: [
        types.HOURLY_BANDWIDTH_USAGE_BY_DEPARTMENT_REQUEST,
        types.HOURLY_BANDWIDTH_USAGE_BY_DEPARTMENT_SUCCESS,
        types.HOURLY_BANDWIDTH_USAGE_BY_DEPARTMENT_FAILURE,
      ]
    });

    const nonDepartmentPromise = dispatch('api', {
      method: 'GET',
      url: `/charts/fib/hourly/${sitecode}?isdepartment=false&${queries.join('&')}`,
      types: [
        types.HOURLY_BANDWIDTH_USAGE_BY_NON_DEPARTMENT_REQUEST,
        types.HOURLY_BANDWIDTH_USAGE_BY_NON_DEPARTMENT_SUCCESS,
        types.HOURLY_BANDWIDTH_USAGE_BY_NON_DEPARTMENT_FAILURE,
      ]
    });

    const values = await Promise.all([departmentPromise, nonDepartmentPromise]);
    if (Array.isArray(values) && values.length > 1) {
      const departmentData = values[0];
      const nonDepartmentData = values[1];
      commit(types.HOURLY_BANDWIDTH_USAGE_FETCH_SUCCESS, {
        department: departmentData,
        nonDepartment: nonDepartmentData
      });
    }
  },


  /// number-of-hits
  async fetchNumberOfHits({dispatch}, {sitecode, dateRange, searchInput}) {
    let queries = [];

    if (dateRange) {
      if (dateRange.startDate) {
        queries.push(`startDate=${dateRange.startDate}`);
      }
      if (dateRange.endDate) {
        queries.push(`endDate=${dateRange.endDate}`);
      }
    }

    if (searchInput) {
      queries.push(`search=${searchInput}`);
    }

    const response = await dispatch('api', {
      method: 'GET',
      url: `/charts/fib/top-hits/${sitecode}?${queries.join('&')}`,
      types: [
        types.NUMBER_OF_HITS_REQUEST,
        types.NUMBER_OF_HITS_SUCCESS,
        types.NUMBER_OF_HITS_FAILURE,
      ]
    });

    return response;
  },


  /// bandwidth-usage
  async fetchBandwidthUsage({dispatch}, {sitecode, dateRange, searchInput}) {
    let queries = [];

    if (dateRange) {
      if (dateRange.startDate) {
        queries.push(`startDate=${dateRange.startDate}`);
      }
      if (dateRange.endDate) {
        queries.push(`endDate=${dateRange.endDate}`);
      }
    }

    if (searchInput) {
      queries.push(`search=${searchInput}`);
    }

    const response = await dispatch('api', {
      method: 'GET',
      url: `/charts/fib/top-bandwidth/${sitecode}?${queries.join('&')}`,
      types: [
        types.BANDWIDTH_USAGE_REQUEST,
        types.BANDWIDTH_USAGE_SUCCESS,
        types.BANDWIDTH_USAGE_FAILURE,
      ]
    });
    return response;
  },


  /**
   * Generic action which dispatches the lifecycle of events of making an API request.
   *
   * @param commit
   * @param rootState
   * @param method string 'GET'|'PUT'|'POST'|'DELETE'
   * @param url
   * @param types
   * @param data
   * @returns {Promise<void>}
   */
  async api({commit, rootState}, {method, url, types, data}) {
    commit(types[0], data);
    try {
      const response = await axios({
        method: method || 'GET',
        url: `${rootState.apiRoot}${url}`,
        headers: {'Authorization': `JWT ${rootState.auth.token}`},
      });

      commit(types[1], {response});
      return response;
    } catch (e) {
      commit(types[2], {exception: e});
      return null;
    }
  },
}
